import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiGet } from "@/lib/api";
import { track, Events } from "@/lib/analytics";
import { toast } from "sonner";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [shortlist, setShortlist] = useState(() => JSON.parse(localStorage.getItem("ec_shortlist") || "[]"));
  const [compare, setCompare] = useState(() => JSON.parse(localStorage.getItem("ec_compare") || "[]"));

  useEffect(() => {
    apiGet("/site-settings").then(setSettings).catch(() => {});
  }, []);

  useEffect(() => {
    localStorage.setItem("ec_shortlist", JSON.stringify(shortlist));
  }, [shortlist]);
  useEffect(() => {
    localStorage.setItem("ec_compare", JSON.stringify(compare));
  }, [compare]);

  const isShortlisted = useCallback((slug) => shortlist.some((p) => p.slug === slug), [shortlist]);

  const toggleShortlist = useCallback((prop) => {
    setShortlist((prev) => {
      if (prev.some((p) => p.slug === prop.slug)) {
        return prev.filter((p) => p.slug !== prop.slug);
      }
      track(Events.SHORTLISTED, { slug: prop.slug });
      toast.success("Added to shortlist");
      return [...prev, { slug: prop.slug, name: prop.name, image: prop.images?.[0], location_name: prop.location_name, price_display: prop.price_display }];
    });
  }, []);

  const isCompared = useCallback((slug) => compare.some((p) => p.slug === slug), [compare]);

  const toggleCompare = useCallback((prop) => {
    setCompare((prev) => {
      if (prev.some((p) => p.slug === prop.slug)) return prev.filter((p) => p.slug !== prop.slug);
      if (prev.length >= 3) {
        toast.error("You can compare up to 3 properties");
        return prev;
      }
      track(Events.COMPARED, { slug: prop.slug });
      return [...prev, prop];
    });
  }, []);

  const clearCompare = useCallback(() => setCompare([]), []);

  return (
    <AppContext.Provider
      value={{ settings, shortlist, compare, isShortlisted, toggleShortlist, isCompared, toggleCompare, clearCompare }}
    >
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used within AppProvider");
  return ctx;
}
